<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12">
        <v-toolbar-title>Home</v-toolbar-title>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="3" md="3">
        <card-widget
          icon="mdi-account-check"
          label="Today's Activation"
          :value="loadingData ? 0 : summaryReports.todaysActivation"
          type="string"
        ></card-widget>
      </v-col>

      <v-col cols="12" lg="3" md="3">
        <card-widget
          icon="mdi-account-multiple-check"
          label="MTD Activation"
          type="string"
          :value="loadingData ? 0 : summaryReports.mtdActivation"
        ></card-widget>
      </v-col>
      <v-col cols="12" lg="3" md="3">
        <card-widget
          icon="mdi-account-group"
          label="Total Activation"
          type="string"
          :value="loadingData ? 0 : summaryReports.totalActivation"
        ></card-widget>
      </v-col>
      <v-col cols="12" lg="3" md="3">
        <card-widget
          icon="mdi-file-percent"
          label="Conversion Rate"
          type="string"
          :value="loadingData ? 0 : summaryReports.conversionRate"
        ></card-widget>
      </v-col>
      <v-col cols="12" lg="3" md="3">
        <card-widget
          icon="mdi-account-off"
          label="Total Declined"
          type="string"
          :value="loadingData ? 0 : summaryReports.totalDecline"
        ></card-widget>
      </v-col>
      <v-col cols="12" lg="3" md="3">
        <card-widget
          icon="mdi-signal-off"
          label="Can't Locate/Contact"
          type="string"
          :value="loadingData ? 0 : summaryReports.cannotLocate"
        ></card-widget>
      </v-col>
      <v-col cols="12" lg="3" md="3">
        <card-widget
          icon="mdi-map-marker-radius"
          label="Total Visited"
          type="string"
          :value="loadingData ? 0 : summaryReports.totalVisited"
        ></card-widget>
      </v-col>
      <v-col cols="12" lg="3" md="3">
        <card-widget
          icon="mdi-map-marker-remove"
          label="Pending Visit"
          type="string"
          :value="loadingData ? 0 : summaryReports.pendingVisit"
        ></card-widget>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col cols="6" lg="6">
        <pie-chart
          :chartOptions="charts.days.chartOptions"
          chartTitle="Re-used / Recovered ONU / Missing ONU"
          :chartWidth="480"
          :chartSeries="charts.days.series"
        ></pie-chart>
      </v-col>
      <v-col cols="6" lg="6">
        <pie-chart
          :chartOptions="charts.days.chartOptions"
          chartTitle="Client not interested"
          :chartWidth="480"
          :chartSeries="charts.days.series"
        ></pie-chart>
      </v-col>
      </v-row> -->

  </v-container>
</template>

<script>
import ShareableMethods from "@/mixins/ShareableMethods";
import CardWidget from "../../components/CardWidget.vue";
//import PieChart from "./components/PieChart.vue";
export default {
  mixins: [ShareableMethods],
  name: "HomeDistributor",
  components: { CardWidget},

  data() {
    return {
      loadingData: true,
      installBalance: 0,
      loadBalance: 0,
      summaryReports: {
            todaysActivation: 0,
            mtdActivation: 0,
            totalActivation: 0,
            conversionRate: 0,
            totalDecline: 0,
            cannotLocate: 0,
            totalVisited: 0,
            pendingVisit: 0
        },
      charts: {
        days: {
          series: [],
          chartOptions: {
            labels: [],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                },
              },
            ],
            legend: {
              position: "bottom",
            },
            noData: {
              text: "Loading...",
            },
            tooltip: {
              y: {
                formatter: function (value) {
                  return value.toLocaleString();
                },
              },
            },
          },
        },
      },
    };
  },

  methods: {
    async getList() {
      const { adminLogin } = this.userData;
      await this.$pds
        .get(`/pds/home?distributorId=`+ adminLogin.distributorId)
        .then((response) => {
          this.loadingData = false;
          const newArr = response.data.data;
         this.summaryReports=newArr.summaryReports;
         console.log(this.summaryReports);
        })
        .catch((e) => {
          this.loadingData = false;
          console.log(e);
        });
    },
    async getHome() {
      await this.$api
        .get(`csp-home`)
        .then((response) => {
          const res = response.data;
          // console.log("asdasdadad a", res);
          this.data = { ...res };

          // console.log( res.graph) //test//test
          res.pie.map((val) => {
            this.charts.days.series.push(val.total);
            this.charts.days.chartOptions.labels.push(val.label);
          });

          this.loadingData = false;
        })
        .catch((e) => {
          this.loadingData = false;
          console.log(e);
        });
    },
  },

  created() {
    this.getList();
    //this.getHome();
  },

  computed: {
    userData() {
      return this.$store.getters.userData;
    },
  },
};
</script>
